import { action } from 'typesafe-actions';

import { CustomerTypes } from './types';

export const setCartAlertAfterBuy = (asked: boolean) =>
  action(CustomerTypes.SET_CART_ALERT_AFTER_BUY, asked);
